import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { HttpUtils } from '../../../../../common/http/http-utils';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class DpsService {
  vdcList: any;
  allDeletedvApps: any;
  storageTrendData: any;

  constructor(public http: HttpClient) {
  }
  getStorageTrend(){
     return this.http
        .get(HttpUtils.getBaseUrl() + '/hybridity/api/dps/storageTrends')
        .map( res => this.storageTrendData = res);
  }
  getDeletedAllVApps(){
    return this.http
      .get(HttpUtils.getBaseUrl() + '/hybridity/api/dps/deletedVApps')
  }
  getAllVDCsList() {
    return this.http
      .get(HttpUtils.getBaseUrl() + '/hybridity/api/dps/vdcs')
      .map( res =>  this.vdcList = res);
  }
}


// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/dashboard/dps-service.service.ts